export default function checkPasswordStrength(username = "", password) {
  if (!password)
    return {
      msg: "Weak: Password cannot be empty.",
      result: false,
      color: "red",
    };
  if (password.length < 6 || password.length > 30)
    return {
      msg: "Weak: Must be at least 6 characters and not more than 30 characters.",
      result: false,
      color: "red",
    };
  if (username && password.toLowerCase() === username.toLowerCase())
    return {
      msg: "Weak: Cannot be same as username.",
      result: false,
      color: "red",
    };
  if (!/[a-zA-Z]/.test(password))
    return {
      msg: "Medium: Can include at least one letter.",
      result: true,
      color: "orange",
    };
  if (!/[0-9]/.test(password))
    return {
      msg: "Medium: Can include at least one number.",
      result: true,
      color: "orange",
    };
  if (/[^a-zA-Z0-9]/.test(password)) {
    return { msg: "Strong", result: true, color: "green" };
  } else {
    return { msg: "Medium", result: true, color: "orange" };
  }
}
